import useAllowedPermission from '@/util/hooks/useAllowedPermission';

import { SUPPLIER_UPDATE_APPROVE_PERMISSIONS } from '../constants/supplierUpdateApprovePermissions';

/**
 * Whether the current user holds at least one of the SupplierUpdateApprove* permissions
 * (27-37). Shared by the Pending Approvals Inbox permission gate, the "Supplier Updates"
 * nav item, and the top-level Approvals badge so all three agree on the same rule.
 */
export const useHasAnySupplierUpdateApprovePermission = () => {
  const { handleHasPermissionCheckFunction: hasPermission, isLoading } =
    useAllowedPermission();

  return {
    hasAnyApprovePermission: SUPPLIER_UPDATE_APPROVE_PERMISSIONS.some(hasPermission),
    isLoading
  };
};
